import React from "react"
import PropTypes from "prop-types"
import { Radio, Typography } from "antd"
import styles from "./BookingForm.module.css"

const { Text } = Typography

const getOptionValue = (option) => {
  const key = option.key
  return key && typeof key === "object" ? key.slot : key
}

const getOptionLabel = (option) => {
  const val = option.value
  return val && typeof val === "object" ? val.slot : val
}

const isOptionDisabled = (option) => {
  const key = option.key
  return key && typeof key === "object" ? key.available === false : false
}

const normalizeSelected = (val) => (val && typeof val === "object" ? val.slot : val)

const TimeDurationSelector = ({ options, selectedValue, onChange, disabled }) => {
  console.log(options)
  const normalizedSelected = normalizeSelected(selectedValue)

  return (
    <div className={styles.optionSelectorWrapper}>
      <Radio.Group
        className={styles.radioGroup}
        optionType="button"
        value={normalizedSelected}
        onChange={(e) => {
          const selected = (options || []).find((opt) => getOptionValue(opt) === e.target.value)
          if (selected) onChange(selected)
        }}
      >
        {options?.map((option) => {
          const val = getOptionValue(option)
          return (
            <Radio.Button
              key={val}
              value={val}
              className={normalizedSelected === val ? `${styles.radioButton} ${styles.radioButtonChecked}` : styles.radioButton}
              disabled={disabled || isOptionDisabled(option)}
            >
              {getOptionLabel(option)}
            </Radio.Button>
          )
        })}
      </Radio.Group>
      {options?.length === 0 && <Text type="secondary">No slots available</Text>}
    </div>
  )
}

TimeDurationSelector.propTypes = {
  options: PropTypes.array.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default React.memo(TimeDurationSelector)
